import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class Invest {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <div class="fg-invest-grid" style="display: flex; justify-content: center; padding: 2rem 0;">
                <article class="fg-project-card" style="max-width: 450px; width: 100%;">
                    <div class="fg-project-card__hero">
                        <img src="/images/logo2.png" alt="footballgirl" style="width: 80px; height: auto;">
                    </div>
                    <div class="fg-project-card__body" style="text-align: center;">
                        <h3 class="fg-project-card__title"><span class="fg-brand-football">football</span><span class="fg-brand-girl">girl</span></h3>
                        
                        <div style="margin: 2.5rem 0; padding: 1.5rem 0; border-top: 1px solid var(--border-color); border-bottom: 1px solid var(--border-color);">
                            <h2 style="font-size: 1.6rem; font-weight: 800; color: var(--primary-blue); letter-spacing: 1px; margin: 0;">
                                Q1 2026 REPORT
                            </h2>
                        </div>

                        <button type="button" class="fg-btn fg-btn--primary fg-read-report-btn">Read here</button>
                    </div>
                </article>
            </div>
        `;

        el.innerHTML = sidebarPage({
            title: 'Invest',
            subtitle: 'Institutional updates and quarterly performance reporting.',
            main,
            wide: true
        });

        el.querySelector('.fg-read-report-btn')?.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('fg:navigate', {
                detail: { page: 'footballgirl-report' }
            }));
        });
    }
}
